export default __webpack_public_path__ + "static/media/person.6d595476.svg";